export const unlockedTutorialsResourceType = "unlocked_tutorial_item" as const;

export const getUnlockedTutorialsListPath = (userGroupId: string) => {
  return `/user_groups/${userGroupId}/unlocked_tutorials`;
};
